var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading3_container"},[_c('div',{staticClass:"pyramid-loader"},[_c('div',{staticClass:"wrapper"},[_c('span',{staticClass:"side side1"}),_c('span',{staticClass:"side side2"}),_c('span',{staticClass:"side side3"}),_c('span',{staticClass:"side side4"}),_c('span',{staticClass:"shadow"})])])])
}]

export { render, staticRenderFns }